<template>
    <div class="profile_container">
        <Header></Header>
        <Achievement></Achievement>
        <About></About>
        <Gallery></Gallery>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import About from '../components/ConsultancyProfile/_about';
import Header from '../components/ConsultancyProfile/_header';
import Achievement from '../components/ConsultancyProfile/_achievement';
import Gallery from '../components/ConsultancyProfile/_gallery';
export default {
    components: {
        About,
        Header,
        Achievement,
        Gallery
    },
    computed: {
        ...mapGetters(['consultancy'])
    },
    mounted(){
        this.title = this.consultancy.client_name;        
        document.title = `${this.title} - Consultancy Finder`;
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/ConsultancyProfile.vue